import React from "react";
import shipRegistrationRoutes from "./shipRegistration/shipRegistrationRoutes";

const vesselRoutes = [
    ...shipRegistrationRoutes,
    {
        path: "/vessel/profile/list",
        component: React.lazy(() =>
            import("./vesselProfile/VesselProfileList")
        )
    },
    {
        path: "/vessel/profile/:viewType/:appId",
        component: React.lazy(() =>
            import("./vesselProfile/ShipFleetFormDetails")
        )
    }
];

export default vesselRoutes;